import { ArrowUpRight, Building2, Lightbulb, UserRound } from 'lucide-react';

const iconMap = {
  SUCURSAL: Building2,
  CHOFER: UserRound,
};

export default function InsightItem({ item }) {
  const Icon = iconMap[item.entidadTipo] || Lightbulb;
  return (
    <article className="rounded-2xl border border-[rgba(var(--border),0.68)] bg-[rgba(var(--subpanel),0.9)] px-3 py-3 shadow-[0_12px_26px_rgba(var(--shadow),0.06)]">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl bg-[rgba(var(--brand),0.12)] text-[rgb(var(--brand))]">
          <Icon className="h-4 w-4" />
        </div>
        <div className="min-w-0">
          <div className="inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-[rgba(var(--muted),0.9)]">
            {item.severidad}
            <ArrowUpRight className="h-3.5 w-3.5" />
          </div>
          <h3 className="mt-1 text-sm font-semibold text-[rgb(var(--fg))]">{item.titulo}</h3>
          <p className="mt-1 text-sm leading-5 text-[rgba(var(--muted),0.96)]">{item.descripcion}</p>
        </div>
      </div>
    </article>
  );
}
